import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ComponentSyncState {
  activeTimestamp: string | number
}

export const initialState = { activeTimestamp: '' } as ComponentSyncState;

const syncSlice = createSlice({
  name: 'componentSync',
  initialState,
  reducers: {
    updateActiveTimestamp(draft, action: PayloadAction<number>) {
      return { ...draft, activeTimestamp: action.payload };
    },
  },
});

export const { updateActiveTimestamp } = syncSlice.actions;
export default syncSlice.reducer;
